// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"error_wrapper__osKdT","content":"error_content__JbA7e","buttonsWrapper":"error_buttonsWrapper__4hq8z"};